import React from "react";
import Auth from "../helpers/auth";

const UserDeveloperInfo = ({user, companyId}) => {
    const auth = Auth.getAll(user.userStatus, companyId);
    console.log(user.lastName, auth)
    const children = Object.entries(auth).map(e => {
        const txt = e[1] ? `${e[0]}, `: '';
        const className = `text-${e[1] ? "dark":"secondary"}`
        return <span className={className}>{txt}</span>
    });
   
    return(
        <h6>{`${user.firstName} ${user.lastName} (${user.userStatus}): `}
            <span>
                {children.map((c,idx) => <span key={idx}>{c}</span>)}
            </span>
        </h6>
    )
};
export default UserDeveloperInfo;